import React from 'react';
import { CLIENT_REPORTING_STOCKS } from './ClientReportingStocks';

/** Branded tile styling per world-market symbol (matches Stocks sidebar polish). */
export const MARKET_VISUALS = {
  YM: { label: 'DJI', theme: 'ym' },
  QQQ: { label: 'NDX', theme: 'qqq' },
  SPY: { label: 'SPX', theme: 'spy' },
  ES: { label: 'ES', theme: 'es' },
  NQ: { label: 'NQ', theme: 'nq' },
  GLD: { label: 'GLD', theme: 'gld' },
  IEF: { label: '10Y', theme: 'ief' },
  CL: { label: 'CL', theme: 'cl' },
  FCHI: { label: 'FCHI', theme: 'fchi' },
  FTSE: { label: 'FTSE', theme: 'ftse' },
  GDAXI: { label: 'DAX', theme: 'gdaxi' },
  N100: { label: 'N100', theme: 'n100' },
  SSMI: { label: 'SSMI', theme: 'ssmi' },
  STOXX50E: { label: 'STOXX', theme: 'stoxx50e' },
  AXJO: { label: 'AXJO', theme: 'axjo' },
  HSI: { label: 'HSI', theme: 'hsi' },
  KS11: { label: 'KS11', theme: 'ks11' },
  N225: { label: 'N225', theme: 'n225' },
  NSEI: { label: 'NSEI', theme: 'nsei' },
  SSE: { label: 'SSE', theme: 'sse' },
};

export function MarketIcon({ symbol, shortLabel }) {
  const visual = MARKET_VISUALS[symbol] || { label: shortLabel, theme: 'default' };
  const label = visual.label || shortLabel || symbol;

  return (
    <div className={`vd-ml-market-icon vd-ml-market-icon--${visual.theme}`} aria-hidden="true">
      <span className="vd-ml-market-icon-label">{label}</span>
    </div>
  );
}

/**
 * The icon a symbol already uses in the sidebar, wherever it is shown.
 *
 * Two sources, deliberately: the stock watchlist has real logo PNGs in
 * /public/stocks, while world markets use themed lettered tiles. The symbol
 * page must show the SAME mark the row the user clicked showed — a different
 * badge on the destination reads as a different instrument.
 */
export function SymbolIcon({ symbol, size = 'md' }) {
  const key = String(symbol || '').toUpperCase();
  const stock = CLIENT_REPORTING_STOCKS.find((s) => s.symbol === key);

  if (stock?.logo) {
    return (
      <div
        className={`vd-ml-stock-icon vd-ml-stock-icon--${key.toLowerCase()} vd-sym-icon--${size}`}
        aria-hidden="true"
      >
        <img src={stock.logo} alt="" />
      </div>
    );
  }

  const visual = MARKET_VISUALS[key];
  if (visual) {
    return (
      <div
        className={`vd-ml-market-icon vd-ml-market-icon--${visual.theme} vd-sym-icon--${size}`}
        aria-hidden="true"
      >
        <span className="vd-ml-market-icon-label">{visual.label}</span>
      </div>
    );
  }

  // Unknown symbol: a neutral tile rather than a broken image.
  return (
    <div className={`vd-ml-market-icon vd-ml-market-icon--default vd-sym-icon--${size}`} aria-hidden="true">
      <span className="vd-ml-market-icon-label">{key.slice(0, 4)}</span>
    </div>
  );
}
